import Axios from "axios";
import {
    SET_HRM_RELIGION_LIST,
    UNSET_HRM_RELIGION_LIST,
  } from "@/store/mutation-types";
import {getHrmReligionList} from "@/store/api";
// initial state
const state = {
  getHrmReligionList: [],
};

const getters = {
  getHrmReligionList(state) {
    return state.getHrmReligionList;
  },
};

const mutations = {
  [SET_HRM_RELIGION_LIST](state, data) {
    state.getHrmReligionList = data;
  },
  [UNSET_HRM_RELIGION_LIST](state) {
    state.getHrmReligionList = [];
  },

};

const actions = {

  getHrmReligionList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getHrmReligionList, data)
        .then(function (response) {
          commit('SET_HRM_RELIGION_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_HRM_RELIGION_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
